import { useContext } from 'react';
import { Link2 } from 'lucide-react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { VideoSyncStateContext } from './CompareViewContext';
import { useTranslation } from 'react-i18next';

export function SyncPlayToggleButton() {
  const { t } = useTranslation('projects');

  const state = useContext(VideoSyncStateContext);
  if (!state?.videosReady) return null;

  const { syncEnabled, setSyncEnabled } = state;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="sm"
            variant={syncEnabled ? 'secondary' : 'outline'}
            onClick={() => setSyncEnabled(!syncEnabled)}
            aria-label={
              syncEnabled
                ? t('projectDetail.syncPlayToggleButton.disableSyncPlayback')
                : t('projectDetail.syncPlayToggleButton.enableSyncPlayback')
            }
            className="h-8 gap-1.5"
          >
            <Link2 className="size-4" />
            {syncEnabled
              ? t('projectDetail.syncPlayToggleButton.synced')
              : t('projectDetail.syncPlayToggleButton.sync')}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {syncEnabled
            ? t('projectDetail.syncPlayToggleButton.disableSyncPlayback')
            : t('projectDetail.syncPlayToggleButton.syncPlaybackAcrossBothVideos')}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
